import {toaster} from '@cypro/ui/toaster'

/** Keep the object URL alive long enough for the new tab to load the document. */
const REVOKE_DELAY_MS = 60_000

/**
 * Opens a generated PDF in a new tab, where the user can print or save it. The automatic print is
 * not a user gesture, so pop-up blockers can stop it — the caller's message says so.
 */
export function openPdfBlob(blob: Blob, popupBlockedMessage: string) {
  const url = URL.createObjectURL(blob)
  const opened = window.open(url)
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS)

  if (!opened) toaster.warning({title: popupBlockedMessage})
}
